module.exports = __webpack_public_path__ + "static/media/dec-voided-check.2ea52017.png";